'use strict';
import { BaseFilter } from './base-filter';
import template from './boolean-filter.html';

export class BooleanFilter extends BaseFilter {
	constructor(options) {
		super(options);

		this.type = 'boolean';
		this.panelTemplate = template;

		this.items = [
			{
				title: this.i18n.get('solutionBuilderAgent.components.mx-conditions-builder.true'),
				value: [true],
			},
			{
				title: this.i18n.get('solutionBuilderAgent.components.mx-conditions-builder.false'),
				value: [false, null],
			},
		];
		this.operators = [this.allOperators.In];
	}

	getNewValue() {
		return this.valueOnForm.value;
	}

	updateTitle() {
		this.title = this.valueOnForm.title || '';
	}

	setDefault() {
		this.valueOnForm = {};
	}

	hasValue() {
		return Boolean(this.value);
	}

	isFormValid() {
		return typeof this.valueOnForm.value !== 'undefined';
	}
}
